import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "map-elem-info land-ap-emergency" }
const _hoisted_2 = { class: "col-info" }
const _hoisted_3 = { class: "row1 mb6" }
const _hoisted_4 = { class: "ft-bold" }
const _hoisted_5 = { class: "ib val" }
const _hoisted_6 = { class: "right-side mr8" }
const _hoisted_7 = { class: "move-buttons mt2" }
const _hoisted_8 = { class: "row2" }
const _hoisted_9 = { class: "ib val" }
const _hoisted_10 = { class: "ib val" }
const _hoisted_11 = { class: "row3 mb6" }
const _hoisted_12 = { class: "val" }
const _hoisted_13 = { class: "val" }
const _hoisted_14 = { class: "row4 mb6" }
const _hoisted_15 = { class: "image-preview-area" }
const _hoisted_16 = {
  key: 0,
  class: "image-box"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 0,
  class: "buttons ta-right mr8"
}

import extLandApEmergencyApi from 'src/apis/extLandApEmergency';
import { computed } from 'vue';
import type { MapElemInfo } from 'src/models';
import type { Emergency } from 'src/models/extLandApEmergency';
import useMapElemInfoImagePreview from 'src/composables/useMapElemInfoImagePreview';
import { dtFormat } from 'src/lib/dateHelper';

interface Props {
  elem: MapElemInfo<Emergency>;
}

const iconPath = '/static/img/land_ap_emergency_pin.png';


export default /*@__PURE__*/_defineComponent({
  __name: 'MapElemInfoLandApEmergency',
  props: {
    elem: {}
  },
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const emergency = computed<Emergency>(() => props.elem.data);
const dateDisp = computed<string>(() => dtFormat(emergency.value.ts));

const modalTitle = computed<string>(() => `${dateDisp.value} - ${emergency.value.landmarkDisp || ''}`);
const downloadFilenameTemplate = computed<string>(() => {
  const emergencyTs = dtFormat(emergency.value?.ts, 'yyyymmddHHMMSS');
  return `${emergency.value?.id}_${emergencyTs}_$TIMESTAMP.jpg`;
});
const { showPrevious, showNext, savedImage, showImage } = useMapElemInfoImagePreview({
  emit,
  elem: computed(() => props.elem),
  refMapElemInfoData: emergency,
  fetchApiFn: () => { return extLandApEmergencyApi.getImage(emergency.value.id); },
  modalTitle,
  downloadFilenameTemplate,
});

const openEmergencies = () => {
  window.open(emergency.value?.emergenciesLink, '_blank');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "col-icon" }, [
      _createElementVNode("img", {
        class: "resource-icon",
        src: iconPath
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "ib lbl" }, "日時: ", -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(dateDisp.value), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "btn btn-primary btn-xs mr4",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(showPrevious) && _unref(showPrevious)(...args)))
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1),
              _createTextVNode(" 前へ ", -1)
            ]))]),
            _createElementVNode("button", {
              class: "btn btn-primary btn-xs",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(showNext) && _unref(showNext)(...args)))
            }, [...(_cache[5] || (_cache[5] = [
              _createTextVNode(" 次へ ", -1),
              _createElementVNode("i", { class: "fas fa-arrow-right" }, null, -1)
            ]))])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "ib lbl" }, "車両番号: ", -1)),
          _createElementVNode("span", _hoisted_9, _toDisplayString(emergency.value.deviceName), 1),
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "ib lbl ml12" }, "動画種別: ", -1)),
          _createElementVNode("span", _hoisted_10, _toDisplayString(emergency.value.movieTypeDisp), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("span", null, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "lbl" }, "地名: ", -1)),
            _createElementVNode("span", _hoisted_12, _toDisplayString(emergency.value.localAddress), 1)
          ], 512), [
            [_vShow, emergency.value.localAddress]
          ]),
          _withDirectives(_createElementVNode("span", null, [
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "lbl" }, "場所: ", -1)),
            _createElementVNode("span", _hoisted_13, _toDisplayString(emergency.value.landmarkDisp), 1)
          ], 512), [
            [_vShow, emergency.value.landmarkDisp]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          (_unref(savedImage))
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("img", {
                  src: _unref(savedImage),
                  class: "image",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(showImage) && _unref(showImage)(...args)))
                }, null, 8, _hoisted_17)
              ]))
            : _createCommentVNode("", true)
        ]),
        (!!emergency.value.emergenciesLink)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-info",
                onClick: openEmergencies
              }, " 緊急通報を開く ")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})